import { userApi } from "api/TenantSlug/User/api.ts";

import GetUserRequest = App.Http.Requests.User.GetUserRequest;

export function composeGetUserQueryOptions(userId: string, request: GetUserRequest) {
    return {
        queryKey: ["getUser", userId, { ...request }],
        queryFn: () => userApi.show(userId, request),
    };
}

export function getUserQueryOptions(userId: string, request: GetUserRequest) {
    return {
        ...composeGetUserQueryOptions(userId, request),
        suspense: true,
    };
}
